import { Button, DatePicker, Divider, Input, Modal, Popconfirm, Radio, Table, Upload, UploadProps } from "antd";
import { FileEntity, FileTypeEntity } from "./Entity";
import { URL_file_deleteFile, URL_file_deleteFileEver, URL_file_downloadFile, URL_file_getFileList, URL_file_searchFile, URL_file_uploadFile, URL_updateFile, down, requestUrl } from "./Utils/UrlUtils";
import { CSSProperties, useEffect, useState } from "react";
import { MessageInstance } from "antd/es/message/interface";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import FileItemSearchView from "./FileItemSearchView";
import Base64 from 'base-64';
import { v4 as uuidv4 } from 'uuid';

interface FileItemViewProps {
  data: FileTypeEntity
  id: number,
  messageApi: MessageInstance
}
const styleModel: CSSProperties = {
  padding: 10,
  paddingTop: 5,
  paddingBottom: 5,
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center'
}

export default (p: FileItemViewProps) => {
  const [fileList, setFileList] = useState<FileEntity[]>([])
  const [total, setTotal] = useState<number>(0)
  const [uploadOpen, setUploadOpen] = useState<boolean>(false)
  const [updateFileOpen, setUpdateFileOpen] = useState<boolean>(false)
  const [file, setFile] = useState<any>();      //上传的文件
  const [fileChange,setFileChange] = useState<any>()  //修改文件
  const [loading, setLoading] = useState<boolean>(false)  //是否正在上传
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)  //是否正在修改文件信息
  const [uploadFileMsg, setUploadFileMsg] = useState<FileEntity>({})  //  上传的文件信息

  const [updateFileMsg, setUpdateFileMsg] = useState<FileEntity>({})  //  修改的文件信息

  const [isSearch, setIsSearch] = useState<boolean>(false) //目前显示 是搜索列表还是 全部列表
  const [page, setPage] = useState<number>(1)
  //搜索框 数据start
  const [fileName, setFileName] = useState<string>()
  const [fileUnit, setFileUnit] = useState<string>()
  const [fileCode, setFileCode] = useState<string>()
  const [fileTime, setFileTime] = useState<string>()
  const [isAbolish, setIsAbolish] = useState<string>()
  const [fileTimeDate, setFileTimeDate] = useState<any>()
  const [searchLoading, setSearchLoading] = useState<boolean>(false)
  const clear = () => {
    //搜索框重置
    getFileList(1)
    setFileName('')
    setFileUnit('')
    setFileCode('')
    setIsAbolish('')
    setFileTime('')
    setFileTimeDate(null)
  }

  //搜索框 数据end

  const columns = [
    {
      title: '文件名',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '30%',
      render: (text: any) => <a>{text}</a>,
    },
    {
      title: '发文单位',
      dataIndex: 'unit',
      key: 'unit',
      width: '20%',
      ellipsis: true,
    },
    {
      title: '编号',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: '14%',
    },
    {
      title: '发文或实施时间',
      dataIndex: 'time',
      key: 'time',
      width: '13%'
    },
    {
      title: '是否废止',
      dataIndex: 'isAbolish',
      key: 'isAbolish',
      width: '8%'
    },
    {
      title: '操作',
      dataIndex: 'id',
      width: '15%',
      // key: 'action',
      render: (text: any, record: FileEntity, index: number) => {
        let fileName = record.name ? record.name : ''
        fileName += record.fileSuffix ? record.fileSuffix : ''
        return <span>
          <a onClick={() => down(record)}>下载</a>
          <Divider type="vertical" />
          <a onClick={() => {
            sessionStorage.setItem('f', JSON.stringify(record))
            window.open('/#/PdfPreviewer')
            // const newUUID = uuidv4();
            // console.log('newUUID = '+newUUID)
            // var originUrl = URL_file_downloadFile + '?id=' + record.id; //要预览文件的访问地址，该接口返回文件流
            // var previewUrl = originUrl + '&fullfilename='+newUUID+record.fileSuffix//fullfilename是必须的，有了该参数kkFileView才知道文件名是什么
            // window.open('http://192.168.1.14:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(previewUrl)));
          }}>预览</a>
          <Divider type="vertical" />
          <a onClick={() => {
            setUpdateFileMsg(record)
            setUpdateFileOpen(true)
          }}>修改</a>
          <Divider type="vertical" />
          <Popconfirm
            placement="bottom"
            title={'确认删除？'}
            // description={description}
            okText="确认"
            cancelText="取消"
            onConfirm={() => {
              deleteFile(p.data.id == -1, record.id)
            }}
          >
            <a style={{ marginLeft: '10px' }}>删除</a>
          </Popconfirm>
        </span>
      }
    },
  ];

  /**
   * 删除文件
   */
  const deleteFile = (isDeleteEver: boolean, id?: number) => {
    if (!id) return
    var url = URL_file_deleteFile
    if (isDeleteEver) {
      //表示永久删除文件
      url = URL_file_deleteFileEver
    }
    let body = { id: id }
    requestUrl({
      url: url,
      method: 'POST',
      body: JSON.stringify(body),
      success: (data: any) => {
        p.messageApi.open({ type: 'error', content: '删除成功' });
        getFileList(1)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      }
    })
  }

  /**
   * 获取文件列表
   * @returns 
   */
  const getFileList = (page: number) => {
    let url = URL_file_getFileList + '?page=' + page + '&pageSize=10'
    if (p.data.id != -1) {
      //表示 选择不是回收站   则需要带Id
      url = url + '&id=' + p.data.id
    }
    setIsSearch(false)
    requestUrl({
      url: url,
      method: 'GET',
      success: (data: any) => {
        setFileList(data.data)
        setTotal(data.total)
        setPage(page)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      }
    })
  }

  /**
   * 搜索文件列表
   * @returns 
   */
  const searchFile = (page: number) => {
    if (!fileName && !fileUnit && !fileCode && !isAbolish && !fileTime) return
    let url = URL_file_searchFile + '?page=' + page + '&pageSize=10'
    if (p.data.id != -1) {
      //表示 选择不是回收站   则需要带Id
      url = url + '&id=' + p.data.id
    }
    if (fileName) url += ('&name=' + fileName)
    if (fileUnit) url += ('&unit=' + fileUnit)
    if (fileCode) url += ('&code=' + fileCode)
    if (isAbolish) url += ('&isAbolish=' + isAbolish)
    if (fileTime) url += ('&time=' + fileTime)
    setSearchLoading(true)
    setIsSearch(true)
    requestUrl({
      url: url,
      method: 'GET',
      success: (data: any) => {
        setFileList(data.data)
        setTotal(data.total)
        setPage(page)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally() {
        setSearchLoading(false)
      },
    })
  }

  useEffect(() => {
    // getFileList(1)
    clear()
  }, [p.data])

  const uploadFile = () => {
    const formData = new FormData();
    const data = {
      unit: uploadFileMsg.unit,
      code: uploadFileMsg.code,
      isAbolish: uploadFileMsg.isAbolish,
      time: uploadFileMsg.time + ' 00:00:00',
      fileTypeId: p.data.id
    }
    formData.append('file', file);
    formData.append('data', JSON.stringify(data));
    setLoading(true)
    return requestUrl({
      url: URL_file_uploadFile,
      method: 'POST',
      body: formData,
      isMultipart: true,
      success: (data) => {
        // setFileTypeList(data)
        setUploadOpen(false)
        p.messageApi.open({ type: 'success', content: '上传成功' });
        getFileList(1)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally: () => {
        setLoading(false)
      }
    })
  }

  const updateFile = () => {
    const formData = new FormData();
    if(fileChange) formData.append('file', fileChange);
    formData.append('data', JSON.stringify(updateFileMsg));
    setIsUpdateLoading(true)
    return requestUrl({
      url: URL_updateFile,
      method: 'POST',
      body: formData,
      isMultipart: true,
      success: (data) => {
        setUpdateFileOpen(false)
        p.messageApi.open({ type: 'success', content: '修改成功' });
        getFileList(1)
      },
      fail: (msg) => {
        p.messageApi.open({ type: 'error', content: msg });
      },
      finally: () => {
        setIsUpdateLoading(false)
      }
    })
  }

  // const updateFile = () => {
  //   setIsUpdateLoading(true)
  //   return requestUrl({
  //     url: URL_updateFile,
  //     method: 'POST',
  //     body: JSON.stringify(updateFileMsg),
  //     success: (data) => {
  //       setUpdateFileOpen(false)
  //       p.messageApi.open({ type: 'success', content: '修改成功' });
  //       getFileList(1)
  //     },
  //     fail: (msg) => {
  //       p.messageApi.open({ type: 'error', content: msg });
  //     },
  //     finally: () => {
  //       setIsUpdateLoading(false)
  //     }
  //   })
  // }

  const props: UploadProps = {
    onRemove: (file: any) => {
      setFile(undefined)
    },
    beforeUpload: (file: any) => {
      setFile(file)
      return false;
    }
  };

  const propsFileChange: UploadProps = {
    onRemove: (file: any) => {
      setFileChange(undefined)
    },
    beforeUpload: (file: any) => {
      setFileChange(file)
      return false;
    }
  };

  const isDisable = (): boolean => {
    if (!uploadFileMsg.unit || !uploadFileMsg.code || !uploadFileMsg.isAbolish || !uploadFileMsg.time
      || !p.data.id || !file) {
      return true
    }
    return false
  }

  const isUpdateDisable = (): boolean => {
    if (!updateFileMsg.unit || !updateFileMsg.code || !updateFileMsg.isAbolish || !updateFileMsg.time
      || !p.data.id) {
      return true
    }
    return false
  }
  return (
    <>
      <div>
        <div style={{ paddingBottom: '20px', paddingTop: '20px', display: 'flex' }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'black' }}>{p.data.name}</div>
        </div>
        <FileItemSearchView
          fileName={fileName}
          setFileName={setFileName}
          fileUnit={fileUnit}
          setFileUnit={setFileUnit}
          fileCode={fileCode}
          setFileCode={setFileCode}
          fileTime={fileTime}
          setFileTime={setFileTime}
          isAbolish={isAbolish}
          setIsAbolish={setIsAbolish}
          searchLoading={searchLoading}
          setSearchLoading={setSearchLoading}
          clear={clear}
          searchFile={searchFile}
          fileTimeDate={fileTimeDate}
          setFileTimeDate={setFileTimeDate} />
        {
          p.data.id == -1 ? <></>//表示选中的回收站 不显示上传文件按钮
            : <div style={{ display: 'flex' }}>
              <Button type="primary" onClick={() => {
                setUploadOpen(true)
              }}>上传文件</Button>
            </div>
        }
        <Table
          style={{ flex: '1', marginTop: '20px' }}
          columns={columns}
          onChange={(pagination) => {
            if (isSearch) searchFile(pagination.current ? pagination.current : 1)
            else getFileList(pagination.current ? pagination.current : 1)

          }}
          pagination={{ total: total, current: page }}
          dataSource={fileList} />
      </div>

      <Modal
        open={uploadOpen}
        destroyOnClose
        title={"上传文件"}
        maskClosable={false}
        onOk={() => setUploadOpen(false)}
        onCancel={() => setUploadOpen(false)}
        afterClose={() => {
          setUploadFileMsg({})
          setFile(undefined)
        }}
        footer={() => (
          <Button
            type="primary"
            onClick={() => uploadFile()}
            disabled={isDisable()}
            loading={loading}
          >
            {loading ? '正在上传' : '上传'}
          </Button>
        )}
      >
        <div style={styleModel}>
          发文单位：<Input style={{ flex: 1 }} value={uploadFileMsg?.unit} onChange={(e) => {
            let newO = Object.assign({}, uploadFileMsg)
            newO.unit = e.target.value
            setUploadFileMsg(newO)
          }} />
        </div>
        <div style={styleModel}>
          编&emsp;&emsp;号：<Input style={{ flex: 1 }} value={uploadFileMsg?.code} onChange={(e) => {
            let newO = Object.assign({}, uploadFileMsg)
            newO.code = e.target.value
            setUploadFileMsg(newO)
          }} />
        </div>
        <div style={styleModel}>
          发文时间：
          <DatePicker
            style={{ flex: 1 }}
            placeholder="请选择发文时间"
            onChange={(value, dateString) => {
              let newO = Object.assign({}, uploadFileMsg)
              newO.time = dateString
              setUploadFileMsg(newO)
            }} />
        </div>
        <div style={styleModel}>
          是否废止：
          <Radio.Group onChange={(e) => {
            let newO = Object.assign({}, uploadFileMsg)
            newO.isAbolish = e.target.value
            setUploadFileMsg(newO)
          }} value={uploadFileMsg.isAbolish}>
            <Radio value={'否'}>否</Radio>
            <Radio value={'是'}>是</Radio>
          </Radio.Group>
        </div>
        <div style={{ marginTop: '10px' }}>
          <Upload {...props} maxCount={1} accept=".docx,.pdf">
            <Button icon={<UploadOutlined />}>选择文件</Button>
          </Upload>
        </div>
      </Modal>

      <Modal
        open={updateFileOpen}
        destroyOnClose
        title={"修改文件"}
        maskClosable={false}
        onOk={() => setUpdateFileOpen(false)}
        onCancel={() => setUpdateFileOpen(false)}
        afterClose={() => {
          setUpdateFileMsg({})
        }}
        footer={() => (
          <Button
            type="primary"
            onClick={() => updateFile()}
            disabled={isUpdateDisable()}
            loading={isUpdateLoading}
          >
            {isUpdateLoading ? '正在修改' : '修改'}
          </Button>
        )}
      >
        <div style={styleModel}>
          文&ensp;件&ensp;名：{updateFileMsg.name}
        </div>
        <div style={styleModel}>
          发文单位：<Input style={{ flex: 1 }} value={updateFileMsg?.unit} onChange={(e) => {
            let newO = Object.assign({}, updateFileMsg)
            newO.unit = e.target.value
            setUpdateFileMsg(newO)
          }} />
        </div>
        <div style={styleModel}>
          编&emsp;&emsp;号：<Input style={{ flex: 1 }} value={updateFileMsg?.code} onChange={(e) => {
            let newO = Object.assign({}, updateFileMsg)
            newO.code = e.target.value
            setUpdateFileMsg(newO)
          }} />
        </div>
        <div style={styleModel}>
          发文时间：
          <DatePicker
            style={{ flex: 1 }}
            placeholder="请选择发文时间"
            defaultValue={dayjs(updateFileMsg.time)}
            onChange={(value, dateString) => {
              console.log(value)
              let newO = Object.assign({}, updateFileMsg)
              newO.time = dateString
              setUpdateFileMsg(newO)
            }} />
        </div>
        <div style={styleModel}>
          是否废止：
          <Radio.Group onChange={(e) => {
            let newO = Object.assign({}, updateFileMsg)
            newO.isAbolish = e.target.value
            setUpdateFileMsg(newO)
          }} value={updateFileMsg.isAbolish}>
            <Radio value={'否'}>否</Radio>
            <Radio value={'是'}>是</Radio>
          </Radio.Group>
        </div>
        <div style={{ marginTop: '10px' }}>
          <Upload {...propsFileChange} maxCount={1} accept=".docx,.pdf">
            <Button icon={<UploadOutlined />}>选择文件</Button>
          </Upload>
        </div>
      </Modal>
    </>

  )
}

export type { FileItemViewProps }